import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_notification_card = _resolveComponent("notification-card")!
  const _component_q_item = _resolveComponent("q-item")!

  return (_openBlock(), _createBlock(_component_q_item, { class: "s-notification--list" }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notifications, (item, k) => {
        return (_openBlock(), _createElementBlock("div", { key: k }, [
          (k !== 0)
            ? (_openBlock(), _createBlock(_component_q_separator, {
                key: 0,
                class: "s-mt-md"
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_notification_card, {
            notification: item,
            onSetNotificationReaded: ($event: any) => (_ctx.$emit('setNotificationReaded', item.id))
          }, null, 8, ["notification", "onSetNotificationReaded"])
        ]))
      }), 128))
    ]),
    _: 1
  }))
}